import { Module } from '../Module';
import { Sandbox } from 'lib/vendor/terrific/Sandbox';
import { Registry } from 'lib/vendor/terrific/Application';

export interface Extend {
	(moduleDefinition : any) : typeof Module
}

export let extend : Extend = moduleDefinition => {
	class SubModule extends Module {
		constructor($ctx : JQuery, sandbox : Sandbox, id : number, modName : string) {
			super($ctx, sandbox, id, modName);
			// Legacy compatibility:
			// Call `init` (the constructor from “Base”)
			this.init($ctx, sandbox, id);
		}

		protected _super(_$ctx : JQuery, _sandbox : Sandbox, _id : number) {
			// Make sure a _super call from an overridden `init` does not call the super constructor again
			this.log.info('call to _super ignored on legacy module');
		}

		// tslint:disable-next-line:prefer-function-over-method
		protected init(_$ctx : JQuery, _sandbox : Sandbox, _id : number) {
			// May be overridden
		}
	}

	// Extend the new module with the properties and methods from the definition
	Object.assign(SubModule.prototype, moduleDefinition);

	return SubModule;
};

export function mergeRegistries(target : Registry, ...sources : Registry[]) {
	for(const sourceRegistry of sources) {
		// Merge two registries
		for(const moduleName in sourceRegistry) {
			const sourceDefinition = sourceRegistry[moduleName];

			if(moduleName in target) {
				const targetDefinition = target[moduleName];
				if(
					targetDefinition.module &&
					sourceDefinition.module &&
					targetDefinition.module !== sourceDefinition.module
				) {
					// Module exists in both registries
					window.debug.error(
						`Tc.Module.${moduleName} has conflicting implementations. Replacing.`,
						targetDefinition.module,
						'with',
						sourceDefinition.module,
					);
				} else if(targetDefinition.module) {
					// Module is defined only in target, not in source
					sourceDefinition.module = targetDefinition.module;
				}

				// Merge all skins (ignore duplicates for now)
				// Source has precedence
				sourceDefinition.skins = {...targetDefinition.skins, ...sourceDefinition.skins};
			}

			target[moduleName] = sourceDefinition;
		}
	}

	return target;
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/vendor/terrific/utils/extend.ts